@if (notification; as notification) {
  <article class="notification-item flex flex-col gap-1.5 rounded-lg px-2 py-3" [class.is-unread]="!notification.isRead">
    <div class="flex items-center gap-2">
      @if (notification.title) {
        <span class="tag min-w-0 rounded-full px-2 py-1 text-xs font-medium">{{ notification.title }}</span>
      }

      <span class="timestamp ml-auto whitespace-nowrap text-xs">{{ notification.createdAt | timeAgo: now() }}</span>

      @if (!notification.isRead) {
        <span class="unread-dot size-1.5 shrink-0 rounded-full"></span>

        <button
          mat-icon-button
          type="button"
          class="mark-as-read-button"
          [matTooltip]="'NOTIFICATIONS.PANEL.MARK_AS_READ' | translate"
          [attr.aria-label]="'NOTIFICATIONS.PANEL.MARK_AS_READ' | translate"
          (click)="markAsRead.emit(notification)">
          <mat-icon>check</mat-icon>
        </button>
      }
    </div>

    @if (notification.subTitle) {
      <span class="sub-title text-xs">{{ notification.subTitle }}</span>
    }

    @if (notification.body) {
      <p class="message-line text-sm font-medium">{{ notification.body }}</p>
    }

    @if (notification.executorName) {
      <p class="executor-info flex flex-wrap gap-1 text-xs">
        <span class="executor-info-label">{{ "NOTIFICATIONS.PANEL.EXECUTOR_FIELD" | translate }}</span>
        <span class="executor-info-value">{{ notification.executorName }}</span>
      </p>
    }

    @if (notification.action === "REDIRECT" && notification.actionLabel) {
      <div class="flex">
        <button type="button" class="action-link text-sm font-medium" (click)="executeAction.emit(notification)">
          {{ notification.actionLabel | translate }}
        </button>
      </div>
    }
  </article>
}
